// extracted by mini-css-extract-plugin
export default {"plainItem":"timeline_plainItem__tbDQd","plainBullet":"timeline_plainBullet__cD5J7"};